import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-report-send-notify',
  templateUrl: './report-send-notify.component.html',
  styleUrls: ['./report-send-notify.component.scss'],
})
export class ReportSendNotifyComponent implements OnInit {

  @Output() onClose: EventEmitter<void> = new EventEmitter();

  constructor() { }

  ngOnInit() {}

}
